import React from 'react';
import PropTypes from "prop-types";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';



  
const ConfirmShortCodeModal = ({open, setOpen, mensaje, titulo, callback}) => {

  
  var ltotaltexto = mensaje.length;


 const handleClose = () => {
    setOpen(false);
  };

  const useStyles = makeStyles(() => ({
    longitudIcon: {
      '& svg': {
        fontSize: 22
      }
    }
  }));   

  const classes = useStyles();


  const textotitulomodal = {
  marginTop: '2%',
  width: '100%',
  height: '24px',
  left: '429px',
  top: '361px',
  fontFamily: 'Ubuntu',
  fontStyle: 'normal',
  fontWeight: '700',
  fontSize: '30px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#00182F',
  marginLeft: '-2%',
  marginbottom: '4px'
  };



  const textocontenidomodal = {
    height: '100px',
    marginTop: '35px',
    fontFamily: 'Ubuntu',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
    overflowY: 'hidden',
    marginBottom: '20px',
    marginLeft: '10%',
    marginRight: '10%',
  };

  const textocontenidomodal2 = {
    height: '86px',
    marginTop: '61px',
    fontFamily: 'Ubuntu',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
    overflowY: 'hidden',
    marginBottom: '12px',
    marginLeft: '10%',
    marginRight: '10%',
  };


  const textocontenidomodal3 = {
    height: '86px',
    marginTop: '42px',
    fontFamily: 'Ubuntu',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '24px',
    textAlign: 'center',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)',
    overflowY: 'hidden',
    marginBottom: '25px',
    marginLeft: '10%',
    marginRight: '10%',
  };

  
  const estiloboton = {
    height: '44px', 
    width : '212px', 
    fontFamily: 'Ubuntu',
    fontFtyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px', 
    backgroundColor:'#008C0D',
    display: 'flex', 
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.15px',
    textTransform: 'none',
    Blend: 'Pass through',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    color: '#F4F5F4',
    marginTop: '14px',    
  };

  const estiloboton2 = {
    height: '44px', 
    width : '212px', 
    fontFamily: 'Ubuntu',
    fontFtyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px', 
    backgroundColor:'#008C0D',
    display: 'flex', 
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.15px',
    textTransform: 'none',
    Blend: 'Pass through',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    color: '#F4F5F4',
    marginTop: '12px',      
  };

  const estilobotoncancelar = {
    height: '44px', 
    width : '212px', 
    fontFamily: 'Ubuntu',
    fontFtyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px', 
    backgroundColor:'#FFFFFF',
    color:'#737373',
    display: 'flex', 
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.15px',
    textTransform: 'none',
    Blend: 'Pass through',
    border: '1px solid #737373', 
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25',
    borderRadius: '8px',
    marginRight: '18px',
    marginTop: '14px',      
  };


  const estilobotoncancelar2 = {
    height: '44px', 
    width : '212px', 
    fontFamily: 'Ubuntu',
    fontFtyle: 'normal',
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px', 
    backgroundColor:'#FFFFFF',
    color:'#737373',
    display: 'flex', 
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.15px',
    textTransform: 'none',
    Blend: 'Pass through',
    border: '1px solid #737373', 
    boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25',
    borderRadius: '8px',
    marginRight: '18px',
    marginTop: '12px',      
  };


  const tituloestilo = {
    height: '76px',
    borderBottom: '1px solid #979797' 
  }


  const DialogActionspadding = {
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid #979797', 
    height: '-70%',
    marginbottom: '-10.5%'
  };
  
  return (
    <div>
    <Dialog PaperProps={{ sx: { width: "609px", height: "314px", borderRadius: '8px', overflowY : 'hidden' } }} open={open} >
        <DialogTitle style={tituloestilo}>
          <p style={textotitulomodal}>{titulo}</p>
        </DialogTitle>    
        <div>
          {ltotaltexto  > 102 && 
            <React.Fragment>
              <div style={textocontenidomodal} dangerouslySetInnerHTML={{__html: mensaje}}></div>
            </React.Fragment>
          }
          {ltotaltexto <= 68 && 
            <React.Fragment>
              <div style={textocontenidomodal2} dangerouslySetInnerHTML={{__html: mensaje}}></div>
            </React.Fragment>
          } 
          {(ltotaltexto >= 68 && ltotaltexto <= 102) && 
            <React.Fragment>
              <div style={textocontenidomodal3} dangerouslySetInnerHTML={{__html: mensaje}}></div>
            </React.Fragment>
        }       
        </div>
        <DialogActions style={DialogActionspadding}>
          {ltotaltexto > 102 && 
            <React.Fragment>
              <Button type="button" style={estilobotoncancelar} variant="contained" onClick={handleClose}>Cancelar</Button>
              <Button  style={estiloboton} variant="contained" onClick={callback}>Aceptar</Button>
            </React.Fragment>
          } 
          {ltotaltexto <= 68 && 
            <React.Fragment>
              <Button type="button" style={estilobotoncancelar2} variant="contained" onClick={handleClose}>Cancelar</Button>
              <Button  style={estiloboton2} variant="contained" onClick={callback}>Aceptar</Button>
            </React.Fragment>
          }

          {(ltotaltexto >= 68 && ltotaltexto <= 102) && 
            <React.Fragment>
              <Button type="button" style={estilobotoncancelar} variant="contained" onClick={handleClose}>Cancelar</Button>
              <Button  style={estiloboton} variant="contained" onClick={callback}>Aceptar</Button>
            </React.Fragment>
          }
        </DialogActions>
        <br></br>
      </Dialog>
    </div>
  );
}

ConfirmShortCodeModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  mensaje: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  callback:PropTypes.func.isRequired,
}
  
export default ConfirmShortCodeModal;